import React from 'react';
import { Dayjs } from 'dayjs';
import { Box } from '@mui/material';

const COLORS = {
  green: '#30893C',
  greenHover: '#296C32',
  greenLight: '#E6F4E8',
  greyBg: '#F2F4F7',
  hoverBg: '#F9FAFB',
  border: '#EAECF0',
} as const;

export const DayCell: React.FC<{
  date: Dayjs;
  isCurrentMonth: boolean;
  schedule?: { preorder?: boolean } | null;
  onDateSelect: (date: Dayjs) => void;
}> = ({ date, isCurrentMonth, schedule, onDateSelect }) => {
  const hasSchedule = !!schedule;
  const hasPreorder = schedule?.preorder === true;
  const hasNoPreorder = hasSchedule && schedule?.preorder === false;

  const shouldApplyColor = hasSchedule && isCurrentMonth;
  const bgColor = shouldApplyColor ? (hasPreorder ? COLORS.green : COLORS.greyBg) : 'transparent';
  const textColor = shouldApplyColor && hasPreorder ? '#FFFFFF' : isCurrentMonth ? '#344054' : '#667085';
  const fontWeight = shouldApplyColor ? 600 : isCurrentMonth ? 500 : 400;

  const hoverStyle = isCurrentMonth
    ? hasPreorder
      ? { bgcolor: COLORS.greenHover, transform: 'scale(1.05)' }
      : hasSchedule
      ? { bgcolor: '#E4E7EC', transform: 'scale(1.05)' }
      : { bgcolor: COLORS.hoverBg, border: `1px solid ${COLORS.border}` }
    : {};

  return (
    <Box
      onClick={() => isCurrentMonth && onDateSelect(date)}
      sx={{
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: isCurrentMonth ? 'pointer' : 'default',
        borderRadius: '50%',
        bgcolor: bgColor,
        color: textColor,
        fontSize: '12px',
        fontWeight: fontWeight,
        transition: 'all 0.15s ease-in-out',
        position: 'relative',
        userSelect: 'none',
        '&:hover': hoverStyle,
      }}
    >
      {date.date()}
      {hasNoPreorder && isCurrentMonth && (
        <Box
          sx={{
            position: 'absolute',
            bottom: '6px',
            width: '5px',
            height: '5px',
            borderRadius: '50%',
            bgcolor: COLORS.green,
            border: '1px solid #FFFFFF',
          }}
        />
      )}
    </Box>
  );
};
